import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { IGiftCardIntegrationState, IGiftCard } from '@cakeiteasy/web-utils';
import { GiftCardsApiService } from '../services/gift-cards-api.service';
import { CartState } from '../../cart/store/reducers/cart.reducer';
import { getCartTotalPrice } from '../../cart';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class GiftCardsManagerService {
  public lastGiftCard: IGiftCard;
  public integrationState$ = new BehaviorSubject<IGiftCardIntegrationState>(null);

  public get giftCardCode(): string {
    return this.lastGiftCard && this.lastGiftCard.code || null;
  }

  constructor(private _giftCardsApi: GiftCardsApiService,
              private _cartStore: Store<CartState>) {
    _cartStore.select(getCartTotalPrice)
      .subscribe(() => {
        if (this.lastGiftCard) {
          this.lastGiftCard.isApplied = false;
        }
      });
  }

  public disableGiftCard() {
    if (this.lastGiftCard) {
      this.lastGiftCard.isApplied = false;
    }
  }

  public getGiftCardByCode(code: string): Promise<IGiftCard> {
    return firstValueFrom(this._giftCardsApi.getGiftCardByCode(code))
      .then((res: IGiftCard) => {
        const giftCard = { ...res, code, isApplied: true };
        this.lastGiftCard = giftCard;
        return giftCard;
      });
  }

  public getIntegrationState(countryCode: string): Promise<IGiftCardIntegrationState> {
    return firstValueFrom(this._giftCardsApi.getIntegrationState(countryCode))
      .then((state: IGiftCardIntegrationState) => {
        this.integrationState$.next(state);
        return state;
      });
  }
}
